
type DetailProductInfoProps = {
    name: string;
    star: number;
    review: number;
    numBuyer: number;
    description: string;
    imgSrc?: string;
}

const DetailProductInfo = (props: DetailProductInfoProps) => {
    return (
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="relative">
                <img
                    src={props.imgSrc || 'https://placehold.co/600x400'}
                    alt="HedgeBot Elite"
                    className="w-full h-80 object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-6 left-6 !text-white">
                    <h1 className="text-4xl !text-white font-bold mb-2">{props.name}</h1>
                </div>
            </div>
            <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-4">
                        <div className="flex items-center gap-1">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-star h-5 w-5 text-yellow-400 fill-current"
                            >
                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                            </svg>
                            <span className="text-lg font-semibold">{props.star}</span>
                            <span className="text-gray-500">({props.review} reviews)</span>
                        </div>
                        <div className="flex items-center gap-1 text-gray-500">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-users h-4 w-4"
                            >
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                <circle cx="9" cy="7" r="4"></circle>
                                <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                            </svg>
                            <span>{props.numBuyer} purchased</span>
                        </div>
                    </div>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed">
                    {props.description}
                </p>
            </div>
        </div>
    );
}

export default DetailProductInfo;